import useAgentInterception from '../../../hooks/agentInterception/useAgentInterception.hooks';
import {
  AgentInterceptionType,
  messagingActions,
  TextFrameTransmissionMessage,
} from '../../../reducers/messagingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { selectActiveRestaurantDetails } from '../../../selectors/restaurant';
import { updateItemSlashCommandIdx } from '../../../reducers/menuSlice';
import { TopLevelMenuItem } from '../../../utils/menu';
import { formatCurrency } from '../../../utils/TTSMessage';
import { selectOrderValues } from '../../../selectors/order';
import { TOTAL_PLACEHOLDER } from '../../../constants';

const useAutocompleteMessage = () => {
  const dispatch = useDispatch();
  const [currentMessage, setCurrentMessage] = useState('');
  const { sendAgentInterception } = useAgentInterception();
  const { restaurantName, restaurantCode } = useSelector(
    selectActiveRestaurantDetails
  );
  const { total } = useSelector(selectOrderValues);
  const updateCurrentMessage = (message: string) => {
    setCurrentMessage(message);
  };
  const sendAgentInterventionEvent = (
    type: AgentInterceptionType,
    description?: string
  ) => {
    sendAgentInterception({
      data: {
        type,
        description,
      },
    });
  };
  const sendMessage = (message: string, metadata?: any, title?: string) => {
    message = message.split('{RESTAURANT_NAME}').join(restaurantName);

    if (message.includes(TOTAL_PLACEHOLDER) && total) {
      message = message
        .split(TOTAL_PLACEHOLDER)
        .join(formatCurrency(total, restaurantCode));
    }
    const payload: Partial<TextFrameTransmissionMessage> = {
      data: { payload: message, status: 'final', metadata },
    };
    dispatch(messagingActions.sendMessage(payload as any));
    sendAgentInterventionEvent(AgentInterceptionType.TTS_SENT);
  };

  const sendSlashCommandMessage = (
    item: TopLevelMenuItem,
    isUnifiedMenuEnabled: boolean
  ) => {
    const itemName = item.name;
    let intent = '';
    let sendVal = '';
    if (isUnifiedMenuEnabled) {
      intent = itemName.replace('/', '');
      const { slashCommands, slashCommandIdx } = item;
      if (slashCommands && slashCommandIdx !== undefined) {
        sendVal = slashCommands[slashCommandIdx];
        const newIndex =
          slashCommandIdx === slashCommands.length - 1
            ? 0
            : slashCommandIdx + 1;
        dispatch(updateItemSlashCommandIdx({ itemName, newIndex }));
      }
    } else {
      [intent, sendVal] = itemName.replace('/', '').split(':');
    }
    sendMessage(sendVal, { intent });
  };

  return {
    currentMessage,
    updateCurrentMessage,
    sendMessage,
    sendAgentInterventionEvent,
    sendSlashCommandMessage,
  };
};

export default useAutocompleteMessage;
